module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }